import { domain } from '@finance/domain'
// import { APP, RUN_APP } from '@common/loan-act/env'

// export const logo = (() => {
//   const imgSource = {
//     [APP.ssj]: 'https://marketres.ssjlicai.com/public-vue/loan-wechat/logo-ssj.png',
//     [APP.kn]: 'https://marketres.ssjlicai.com/public-vue/loan-wechat/loog-kn.png',
//   }
//   return imgSource[RUN_APP]
// })()
export const logo = require('$assets/img/common/share-logo.png')

export default `${domain.res}/act/pdt-2020-freeorder-1212/${logo}`